import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png';

import features_1 from '../../assets/img/landingPage/mocking/mocking_01.png'
import features_2 from '../../assets/img/landingPage/mocking/mocking_02.png'
import features_3 from '../../assets/img/landingPage/mocking/mocking_03.png'

import icon_1 from '../../assets/img/landingPage/mocking/icn_Mocking-01.png'
import icon_2 from '../../assets/img/landingPage/mocking/icn_Mocking-02.png'
import icon_3 from '../../assets/img/landingPage/mocking/icn_Mocking-03.png'

import logo from '../../assets/img/logos/AVAP_MockingService-neg.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'
import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'


const MockingServiceProduct = () => {
    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}>
                
                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Mocking Service"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Instant API Mocking for Faster Development</h1>
                    <p className="fl-subtitle">
                    Simulate API behavior with dynamic mocks powered by Gen-AI.


                    </p>
                    <a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>
                </section>

                {/* Powerful API Platform */}
                <section className="container text-center pb-5">
                    <div className="row">
                        <div className="col">
                            {/* <p className="fl-subtitle mb-3">
                                Titulo
                            </p> */}
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            <p className="fl-subtitle mb-3">
                            Accelerate API Development with Intelligent, Realistic Mocking
                            </p>
                            <p className="fl-text">
                            AVAP Mocking Service enables developers to create dynamic, realistic mock APIs that simulate real API behavior during the design and development phases. This service allows teams to test integrations, validate workflows, and develop in parallel without waiting for backend readiness. Leveraging Gen-AI, AVAP Mocking Service can generate intelligent, context-aware mock responses that adapt to various scenarios, enhancing testing accuracy and accelerating time-to-market.


                            </p>
                        </div>
                    </div>

                </section>

                {/* Features */}
                           <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_1} alt="icon_1" />
                                <p>Dynamic API Mocking </p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_2} alt="icon_2" />
                                <p>Gen-AI Response Generation</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_3} alt="icon_3" />
                                <p>Integration with AVAP Framework</p>
                            </div>
                        </div>
                    </div>
                </section> 

                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Image of a code repository representing the organization and management of code for version control"
                                className="img-fluid"
                                style={{ height: '380px' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5">

                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Dynamic Mock APIs with Gen-AI Responses</h3>
                            <p className="fl-text">
                            Generate realistic and adaptive mock responses using Gen-AI, which understands the API schema and simulates data patterns, enabling more accurate testing and development workflows that mimic real-world scenarios.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Seamless Integration with AVAP API Design</h3>
                            <p className="fl-text">
                            Quickly create mocks directly from your AVAP API definitions (OAS or A2ML), enabling developers to work simultaneously on front-end and back-end services without dependencies.


                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Image of version tracking system in AVAP API Source Control."
                                className="img-fluid"
                                style={{ height: '350px' }}
                            />
                        </div>
                    </div>

                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Visual representation of code evolution showing the progression of changes and updates."
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>



                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Configurable Behavior & Scenarios
                            </h3>
                            <p className="fl-text">
                            Customize mock responses based on request parameters, headers, or error conditions. Define multiple scenarios to cover edge cases and validate error handling effectively during early testing phases.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Speed Up Development Cycles
                                </p>
                                <p className="fl-text">
                                Remove blockers by allowing front-end and integration teams to work in parallel with realistic mock APIs, reducing dependency on backend availability.                                    <br />
                                    &nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Improve Testing Accuracy with AI-Driven Mocks

                                </p>
                                <p className="fl-text">
                                Leverage Gen-AI to produce context-aware, variable responses that better simulate real API behavior, improving the quality of integration and system tests.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Enhance Collaboration Across Teams
                                </p>
                                <p className="fl-text">
                                Provide consistent mock environments that align with your AVAP API designs, fostering collaboration and reducing misunderstandings between developers and testers.

                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default MockingServiceProduct;
